module.exports = __webpack_public_path__ + "img/Comic04-3.10365c57.png";